import React from 'react';

import { CheckOutlined } from '@ant-design/icons';
import { Empty, List } from 'antd';
import classNames from 'classnames';

import { EMPTY_MESSAGES } from '@/shared/lib/constants';
import { sanitizeDescription } from '@/shared/lib/sanitize';
import { Button } from '@/shared/ui/Button';

import type { DomainTypeEditHook } from '@/features/domain/model';

import styles from './DomainTypeEditPopover.module.css';

export type DomainTypeEditPopoverProps = {
  domainTypeEdit: DomainTypeEditHook;
};

export const DomainTypeEditPopover: React.FC<DomainTypeEditPopoverProps> = ({ domainTypeEdit }) => {
  const {
    domainTypeOptions,
    selectedDomainType,
    isUpdating,
    hasChanges,
    handleDomainTypeSelect,
    handleUpdate,
    handleClose,
  } = domainTypeEdit;

  return (
    <div className={styles.popover}>
      <div className={styles.listContainer}>
        {domainTypeOptions.length > 0 ? (
          <List<{ value: string; label: string; description: string }>
            dataSource={domainTypeOptions}
            renderItem={(option) => {
              const isSelected = selectedDomainType === option.value;
              return (
                <List.Item
                  onClick={() => handleDomainTypeSelect(option.value)}
                  className={classNames('listItem', styles.listItem, {
                    selected: isSelected,
                  })}>
                  <div className={styles.listItemContent}>
                    <div className={styles.optionInfo}>
                      <div className={styles.optionLabel}>{option.label}</div>
                      <div
                        className={styles.optionDescription}
                        dangerouslySetInnerHTML={{ __html: sanitizeDescription(option.description) }}
                      />
                    </div>
                  </div>
                  {isSelected && (
                    <div className={styles.selectedIndicator}>
                      <CheckOutlined />
                    </div>
                  )}
                </List.Item>
              );
            }}
          />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={EMPTY_MESSAGES.NO_DOMAIN_TYPE} />
        )}
      </div>
      <div className={styles.actions}>
        <div className={styles.buttonGroup}>
          <Button variant="outlined" color="standard" onClick={handleClose}>
            취소
          </Button>
          <Button variant="filled" color="standard" onClick={handleUpdate} loading={isUpdating} disabled={!hasChanges}>
            업데이트
          </Button>
        </div>
      </div>
    </div>
  );
};
